module.exports = __webpack_public_path__ + "static/img/boya.dbbce148.png";